import { Component } from "react"
import { motion } from "framer-motion"

class FieldShaker extends Component {
  constructor(props) {
    super(props)
    this.state = {
      animating: false
    }
  }

  // invoke this method with a ref
  shake() {
    this.setState({ animating: true }, () => {
      setTimeout(() => {
        this.setState({ animating: false })
      }, 200)
    })
  }

  render() {
    const animating = this.props.animating || this.state.animating
    return (
      <motion.div
        className="FieldShaker"
        animate={{ x: animating ? -10 : 0 }}
        transition={{ type: "spring", stiffness: 1480, damping: 12 }}
      >
        {this.props.children}
      </motion.div>
    )
  }
}

export default FieldShaker
